import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import NewsDetail from '../views/news/NewsDetail.vue' // 确保路径正确
import AboutPage from '../views/page/AboutPage.vue' // 确保路径正确
import ProductPage from '../views/page/ProductPage.vue' // 确保路径正确
import ProductListPage from '../views/page/ProductListPage.vue' // 确保路径正确
import SolutionsPage from '../views/page/SolutionsPage.vue' // 确保路径正确
import ScenarioDetailPage from '../views/page/ScenarioDetailPage.vue' // 确保路径正确
import NewsPage from '../views/page/NewsPage.vue' // 确保路径正确
import ServicePage from '../views/page/ServicePage.vue' // 确保路径正确
import ContactUs from '../views/page/ContactUs.vue' // 确保路径正确
import CSRPage from '../views/page/CSRPage.vue' // 确保路径正确

const routes = [
    {
        path: '/',
        name: 'Home',
        component: HomeView
    },
    
    {
        // 路径可以自定义，例如 '/news/:id'，其中 :id 表示一个动态参数
        path: '/news/:id', // 或者你期望的其他路径结构，如 '/news/detail/:id'
        name: 'NewsDetail', // 这个 name 必须与 <router-link> 中的 name 匹配
        component: NewsDetail,
        props: true // 这允许将路由参数作为 props 传递给 NewsDetail 组件
    },
    {
        // 路径可以自定义，例如 '/news/:id'，其中 :id 表示一个动态参数
        path: '/about', // 或者你期望的其他路径结构，如 '/news/detail/:id'
        name: 'AboutPage', // 这个 name 必须与 <router-link> 中的 name 匹配
        component: AboutPage,
        props: true // 这允许将路由参数作为 props 传递给 NewsDetail 组件
    },
    {
        path: '/product',
        name: 'ProductPage',
        component: ProductPage,
        props: true
    },
    {
        // 路径可以自定义，例如 '/news/:id'，其中 :id 表示一个动态参数
        path: '/product_list/:categoryId?', // 或者你期望的其他路径结构，如 '/news/detail/:id'
        name: 'ProductListPage', // 这个 name 必须与 <router-link> 中的 name 匹配
        component: ProductListPage,
        props: true // 这允许将路由参数作为 props 传递给 NewsDetail 组件
    },
    {
        // 路径可以自定义，例如 '/news/:id'，其中 :id 表示一个动态参数
        path: '/solutions/:scenarioId', // 或者你期望的其他路径结构，如 '/news/detail/:id'
        name: 'ScenarioDetailPage', // 这个 name 必须与 <router-link> 中的 name 匹配
        component: ScenarioDetailPage,
        props: true // 这允许将路由参数作为 props 传递给 NewsDetail 组件
    },
    {
        // 路径可以自定义，例如 '/news/:id'，其中 :id 表示一个动态参数
        path: '/solutions', // 或者你期望的其他路径结构，如 '/news/detail/:id'
        name: 'SolutionsPage', // 这个 name 必须与 <router-link> 中的 name 匹配
        component: SolutionsPage,
        props: true // 这允许将路由参数作为 props 传递给 NewsDetail 组件
    },
    {
        // 路径可以自定义，例如 '/news/:id'，其中 :id 表示一个动态参数
        path: '/news', // 或者你期望的其他路径结构，如 '/news/detail/:id'
        name: 'NewsPage', // 这个 name 必须与 <router-link> 中的 name 匹配
        component: NewsPage,
        props: true // 这允许将路由参数作为 props 传递给 NewsDetail 组件
    },
    {
        // 路径可以自定义，例如 '/news/:id'，其中 :id 表示一个动态参数
        path: '/service', // 或者你期望的其他路径结构，如 '/news/detail/:id'
        name: 'ServicePage', // 这个 name 必须与 <router-link> 中的 name 匹配
        component: ServicePage,
        props: true // 这允许将路由参数作为 props 传递给 NewsDetail 组件
    },
    {
        // 路径可以自定义，例如 '/news/:id'，其中 :id 表示一个动态参数
        path: '/contact', // 或者你期望的其他路径结构，如 '/news/detail/:id'
        name: 'ContactUs', // 这个 name 必须与 <router-link> 中的 name 匹配
        component: ContactUs,
        props: true // 这允许将路由参数作为 props 传递给 NewsDetail 组件
    },
    {
        // 企业社会责任页面
        path: '/csr',
        name: 'CSRPage',
        component: CSRPage,
        props: true
    },
    // 在此处添加其他路由，当您创建更多页面时
    // 示例:
    // {
    //   path: '/about',
    //   name: 'About',
    //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    // }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0, behavior: 'smooth' };
        }
    }
})

export default router